import type { FaireProductEntity } from "../../entity_types/product";

export const p_3gfcwg334c: FaireProductEntity = {
  token: "p_3gfcwg334c",
  type: "product",
  name: "Maldon Sea Salt 8.5 oz",
  brandToken: "b_3wqhrgidgj",
  brandName: "Wholesome Good",
  imageUrl:
    "https://cdn.faire.com/fastly/5ce81ff732b690d6fb6460f908b067fff3db378d565b82358c2f05621a516bbd.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.68,
  description:
    "\nYou can taste the difference between common table salt and this superb natural sea salt. Founded in 1882, Englandâ€™s Maldon Salt Crystal Company still draws salt from seawater using traditional long-handled rakes, processing it with no artificial additives for flavor that's pure and clean. Premium all-natural sea salt has a clean taste with no bitterness. The purity of the waterâ€™s trace elements makes this salt more flavorful, so you can use less. Soft, flaky, pyramid-shaped crystals dissolve easily. Use it in cooking or simply sprinkle or crush over food. 8.5 oz. Made in England.\n",
  tags: [],
  msrpDollars: 15.35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:41.945Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
